module.exports = __webpack_public_path__ + "components/flag/static/square/ky-a19c73551a4a3d584722578acfb35548.svg";